import request from '@/utils/request'



// 查询阶段配置下拉列表（用于其他表单选择）
export function getStageConfigSelect(params) {
  return request({
    url: '/system/stageConfig/select',
    method: 'get',
    params: params
  })
}

// 前端专用：根据专业和学期查询阶段配置
// 修改后（正确）
export function getStageConfigByMajorAndXueQi(params) {
  return request({
    url: '/system/stageConfig/getByMajorAndXueQi',
    method: 'get',
    params
  })
}


// 查询阶段名管理列表
export function listOmdstageconfig(query) {
  return request({
    url: '/system/stageConfig/list',
    method: 'get',
    params: query
  })
}

// 查询阶段名管理详细
export function getOmdstageconfig(id) {
  return request({
    url: '/system/stageConfig/' + id,
    method: 'get'
  })
}

// 新增阶段名管理
export function addOmdstageconfig(data) {
  return request({
    url: '/system/stageConfig/',
    method: 'post',
    data: data
  })
}

// 修改阶段名管理
export function updateOmdstageconfig(data) {
  return request({
    url: '/system/stageConfig/',
    method: 'put',
    data: data
  })
}

// 删除阶段名管理
export function delOmdstageconfig(id) {
  return request({
    url: '/system/stageConfig/' + id,
    method: 'delete'
  })
}

